import React, { Component } from 'react'
import Title from '../common/title'
import moment from 'moment'

import AriaMessage from '../common/ariaMessage'
import Controls from '../common/controls'
import * as dateFormatting from './date_formatting'

const MAX_TIMES_DISPLAYED = 5

class Coaching2 extends Component {
  constructor(props) {
    super(props)
    
    this.next = this._next.bind(this)
    this.props.updateActivePage(2)

    this.state = {
      hasSession2: false, 
      hasSession3: false, 
      isSessionConfirmed2: false, 
      isSessionConfirmed3: false,
      allSessionTimes2: [], 
      allSessionTimes3: [], 
      currentSessionTimes: [], 
      currentSessionIndex: 0,  
      session1: '', 
      session2: '',
      session3: '',
      currentSession: '',
      editSession: false,
      session2Initial: true,
      session3Initial: true,
      nextDisabled: false,
    }

    this.setNextSessionTimes = this._setNextSessionTimes.bind(this)
    this.setPreviousSessionTimes = this._setPreviousSessionTimes.bind(this)
  }

  _setNextSessionTimes() {
    let allSessionTimes = null
    switch(this.state.currentSession) {
      case 'session2':
        allSessionTimes = 'allSessionTimes2'
        break
      case 'session3':
        allSessionTimes = 'allSessionTimes3'
        break
      default:
        return null
    }
    if ((this.state.currentSessionIndex + 1) * MAX_TIMES_DISPLAYED < this.state[allSessionTimes].length) {
      let newSessionIndex = this.state.currentSessionIndex + 1
      let newSessionTimes = this.state[allSessionTimes].slice(newSessionIndex * MAX_TIMES_DISPLAYED, newSessionIndex * MAX_TIMES_DISPLAYED + MAX_TIMES_DISPLAYED)
      this.setState({ ...this.state,
        currentSessionTimes: newSessionTimes,
        currentSessionIndex: newSessionIndex
      })
    }
  }

  _setPreviousSessionTimes() {
    let allSessionTimes = null
    switch(this.state.currentSession) {
      case 'session2':
        allSessionTimes = 'allSessionTimes2'
        break
      case 'session3':
        allSessionTimes = 'allSessionTimes3'
        break
      default:
        return null
    }
    if (this.state.currentSessionIndex > 0) {
      let newSessionIndex = this.state.currentSessionIndex - 1
      let newSessionTimes = this.state[allSessionTimes].slice(newSessionIndex * MAX_TIMES_DISPLAYED, newSessionIndex * MAX_TIMES_DISPLAYED + MAX_TIMES_DISPLAYED)
      this.setState({ ...this.state,
        currentSessionTimes: newSessionTimes,
        currentSessionIndex: newSessionIndex
      })
    }
  }

  firstSessionGroup() {
    if (this.state.currentSessionIndex === 0) {
      return 'coaching-transparent'
    }
    return ''
  }

  lastSessionGroup() {
    let allSessionTimes = null
    switch(this.state.currentSession) {
      case 'session2':
        allSessionTimes = 'allSessionTimes2'
        break
      case 'session3':
        allSessionTimes = 'allSessionTimes3'
        break
      default:
        return ;
    }
    if ((this.state.currentSessionIndex + 1) * MAX_TIMES_DISPLAYED >= this.state[allSessionTimes].length) {
      return 'coaching-transparent'
    }
  }

  _next() {
    return this.props.next(this.props.match.path, this.state)
  }
  
  formatSessions(timeSlots) {
    let allSlotTimes = []
    for (let i = 0; i < timeSlots.length; ++i) {
      for (let j = 0; j < timeSlots[i].slotTimes.length; ++j) {
        allSlotTimes.push(moment(timeSlots[i].slotTimes[j]))
      }
    }
    return allSlotTimes
  }

  setSlotTimeSelected(slotTime) {
    let session = this.state[this.state.currentSession]

    if (dateFormatting.dateTimeEqual(session,slotTime)) {
      return ;
    }
    this.setState({ ...this.state,
      [this.state.currentSession]: slotTime,
      [`${this.state.currentSession}Initial`]: false,
    })
  }

  selectedSlotTimeStyle(date) {
    let session = this.state[this.state.currentSession]
    if (dateFormatting.dateTimeEqual(date, session) && this.state[`${this.state.currentSession}Initial`]) {
      return 'initial-session'
    } else if (dateFormatting.dateTimeEqual(date, session)) {
      return 'selected-session'
    }
    return ''
  }

  openSessions() {
    this.setState ({
      editSession: true
    })
  }

  unselectedSession(sessionNum) {
    let isSessionConfirmed = null
    switch(sessionNum) {
      case 'session2':
        isSessionConfirmed = this.state.isSessionConfirmed2 
        break
      case 'session3':
        isSessionConfirmed = this.state.isSessionConfirmed3
        break
      default:
        break
    }
    if (this.state.editSession && this.state.currentSession !== sessionNum && !isSessionConfirmed) {
      return 'unselected-session'
    }
    return ''
  }

  async confirmClick() {
    let currentSession = null
    let isSessionConfirmed = null
    let sessionTime = this.state[this.state.currentSession]
    switch(this.state.currentSession) {
      case 'session2':
        currentSession = 'session3'
        isSessionConfirmed = 'isSessionConfirmed2'
        break
      case 'session3':
        currentSession = 'complete'
        isSessionConfirmed = 'isSessionConfirmed3'
        break
      default:
        return ;
    }
    this.refs[`confirm${this.state.currentSession}`].setAttribute('aria-hidden', 'true')
    this.setState({
      nextDisabled: true
    }, async () => {
      let response = await this.props.createEvent(this.props.history, 'scheduled', 'coaching_session', sessionTime)
      this.refs[`confirm${this.state.currentSession}`].removeAttribute('aria-hidden')
      if (response !== 'success') {
        this.setState({ nextDisabled: false })
        return ;
      } 
  
      let currentSessionIndex = null
      let currentSessionTimes = null
      if (currentSession === 'session3') {
        currentSessionIndex = this.getCurrentSessionIndex(this.state.session3, this.state.allSessionTimes3)
        currentSessionTimes = this.state.allSessionTimes3.slice(currentSessionIndex * MAX_TIMES_DISPLAYED, currentSessionIndex * MAX_TIMES_DISPLAYED + MAX_TIMES_DISPLAYED)
      }
      this.setState({ ...this.state,
        currentSessionIndex,
        currentSessionTimes,
        [isSessionConfirmed]: true,
        currentSession,
        editSession: false,
        nextDisabled: false
      })
    })
  }

  async fetchInitialData() {
    let events = await this.props.getEvents(this.props.history)
    if (!events || events.length === 0) {
      return ;
    }
    events = events.filter(event => event.eventType === 'program_orientation' || event.eventType === 'coaching_session').slice(0, 3)
    let hasSession2 = false
    let hasSession3 = false
    let isSessionConfirmed2 = false
    let isSessionConfirmed3 = false
    let allSessionTimes2 = []
    let allSessionTimes3 = []
    let currentSessionTimes = []
    let currentSessionIndex = 0
    let session1 = null
    let session2 = null
    let session3 = null
    let currentSession = null
    switch (events.length) {
      case 0:
        return null
      case 1:
        session1 = moment(events[0].startTime)
        break
      case 2:
        session1 = moment(events[0].startTime)
        session2 = moment(events[1].startTime)
        hasSession2 = true
        isSessionConfirmed2 = true
        break
      case 3:
        session1 = moment(events[0].startTime)
        session2 = moment(events[1].startTime)
        session3 = moment(events[2].startTime)
        hasSession2 = true
        hasSession3 = true
        isSessionConfirmed2 = true
        isSessionConfirmed3 = true
        currentSession = 'complete'
        
        this.setState({ ...this.state,
          session1,
          session2,
          session3,
          hasSession2,
          hasSession3,
          isSessionConfirmed2,
          isSessionConfirmed3,
          currentSession,
        })
        return null
      default:
        return null
    }
    
    const inspiratorId = events[0].inspiratorRecord
    let firstSessionData = await this.props.findSessions(this.props.history, inspiratorId, session1)
    firstSessionData = firstSessionData && firstSessionData.data
    this.props.addInspiratorHistory(this.props.history, inspiratorId)

    let extraSessionsData = null

    switch (firstSessionData.timeSlots.length) {
      case 1: 
        return this.props.next(this.props.match.path, this.state)
      case 2:
        hasSession2 = true
        if (!isSessionConfirmed2) {
          session2 = moment(firstSessionData.timeSlots[1].slotTimes[0])
        }
        extraSessionsData = await this.props.getInspiratorTimes(this.props.history, moment(firstSessionData.timeSlots[1].slotDate), 2)
        extraSessionsData = extraSessionsData && extraSessionsData.data
        allSessionTimes2 = this.formatSessions(extraSessionsData.timeSlots)
        break
      case 3:
        if (!isSessionConfirmed2) {
          session2 = moment(firstSessionData.timeSlots[1].slotTimes[0])
        } 
        if (!isSessionConfirmed3) {
          session3 = moment(firstSessionData.timeSlots[2].slotTimes[0])
        }
        extraSessionsData = await Promise.all([this.props.getInspiratorTimes(this.props.history, moment(firstSessionData.timeSlots[1].slotDate), 2), this.props.getInspiratorTimes(this.props.history, moment(firstSessionData.timeSlots[2].slotDate), 2)])
        hasSession2 = true
        hasSession3 = true
        allSessionTimes2 = this.formatSessions(extraSessionsData[0].data.timeSlots)
        allSessionTimes3 = this.formatSessions(extraSessionsData[1].data.timeSlots)
        break
      default:
        break
    }
    if (hasSession2 && !isSessionConfirmed2) {
      currentSession = 'session2'
      currentSessionIndex = this.getCurrentSessionIndex(session2, allSessionTimes2)
      currentSessionTimes =  allSessionTimes2.slice(currentSessionIndex * MAX_TIMES_DISPLAYED, currentSessionIndex * MAX_TIMES_DISPLAYED + MAX_TIMES_DISPLAYED)

    } else if (hasSession3 && !isSessionConfirmed3) {
      currentSession = 'session3'
      currentSessionIndex = this.getCurrentSessionIndex(session3, allSessionTimes3)
      currentSessionTimes =  allSessionTimes3.slice(currentSessionIndex * MAX_TIMES_DISPLAYED, currentSessionIndex * MAX_TIMES_DISPLAYED + MAX_TIMES_DISPLAYED)
    } else {
      currentSession = 'complete'
    }


    this.setState({ ...this.state,
      hasSession2,
      hasSession3,
      isSessionConfirmed2,
      isSessionConfirmed3,
      allSessionTimes2,
      allSessionTimes3,
      currentSessionTimes,
      currentSessionIndex,
      session1,
      session2,
      session3,
      currentSession,
      session2Initial: true,
      session3Initial: true,
    })
  }


  async componentDidUpdate() {
    if (this.props.apiError) {
      await this.fetchInitialData()
      this.props.setApiErrorFalse()
    }
  }

  async componentDidMount() {
    this.fetchInitialData()
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  getCurrentSessionIndex(sessionTime, allSessions) {
    for(let i = 0; i < allSessions.length; ++i) {
      if(dateFormatting.dateTimeEqual(sessionTime, allSessions[i])) {
        return  Math.floor(i / MAX_TIMES_DISPLAYED)
      }
    }
  }

  displayCheckedImage(sessionBooked) {
    if (sessionBooked) {
      return <img className="check-circle" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/37d3ea74-4ce0-4b21-9ece-c2628b619b68.png" alt="" />
    }
    return <img className="check-circle" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/475dad56-304e-43b2-a20f-17c81d0d1a6a.png" alt="" />
  }

  displayTimes() {
    let sessionRef = (this.state.editSession && this.state.currentSessionTimes) ? "confirm" + this.state.currentSession : null
    let currentSessionTimes = null
    let chooseSessions = null
    let display = (this.state.editSession && this.state.currentSessionTimes) ? true : false
    if (this.state.editSession && this.state.currentSessionTimes) {
      currentSessionTimes = this.state.currentSessionTimes.map(slotTime => 
        <label key={slotTime.valueOf()} className={"active-session " + this.selectedSlotTimeStyle(slotTime)}>
          <input
            className="time-selector"
            onClick={this.setSlotTimeSelected.bind(this, slotTime)}
            name="time-selector"
            type="radio"
            aria-label={dateFormatting.completeDatePrettyPrint(slotTime)}
            disabled={this.selectedSlotTimeStyle(slotTime) === "initial-session" ? true : false}
          /> 
          <span className="show-session" aria-hidden="true">{dateFormatting.shortDateTimePrettyPrint(slotTime)}</span>
        </label>
      )
    }
      
    chooseSessions =
      <div id="choose-sessions-wrapper">
        <br aria-hidden="true" />
        <div className="time-buttons">
          <input
            id="previous-times"
            className={"session-change " + this.firstSessionGroup()}
            tabIndex={this.firstSessionGroup() ? "-1" : "0"}
            aria-hidden={this.firstSessionGroup() ? "true" : "false"}
            type="image"
            onClick={this.setPreviousSessionTimes}
            aria-label="Previous Sessions Button"
            src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/92aa86b9-c89a-43af-baef-8dc2fbe0bd6c.png"
            alt=""
          />
          <div id="displayed-session-times" className="selected-session-times" role="radiogroup">
            {currentSessionTimes ? currentSessionTimes : <div></div>}
          </div> 
          <input
            id="next-times"
            className={"session-change "  + this.lastSessionGroup()}
            tabIndex={this.lastSessionGroup() ? "-1" : "0"}
            aria-hidden={this.lastSessionGroup() ? "true" : "false"}
            type="image"
            onClick={this.setNextSessionTimes}
            aria-label="Next Sessions Button"
            src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/bfe73c46-b4b2-45a2-a322-6003a55d7f3c.png"
            alt=""
          />
        </div>
      </div>
    return (
      <div aria-live="polite">
        {display &&
          <div>
            {chooseSessions}
            <div className="confirm-button-wrapper">
              <button className="coaching-button coaching-confirm" ref={sessionRef} disabled={this.state.nextDisabled} onClick={this.confirmClick.bind(this)}>CONFIRM</button>
            </div>
          </div>
        }
      </div>
    )
  } 

  editConfirmOrDropdwon(sessionNum) {
    let isSessionConfirmed = null
    let sessionRef = "confirm" + sessionNum
    switch (sessionNum) {
      case 'session2':
        isSessionConfirmed = this.state.isSessionConfirmed2 
        break
      case 'session3':
        isSessionConfirmed = this.state.isSessionConfirmed3 
        break
      default:
        return null
    }

    if (isSessionConfirmed) {
      return (
        <div className="coaching2-subheader">
          BOOKED
        </div>
      )
    } else if (this.state.currentSession === sessionNum && this.state.editSession) {
      return <img className="dropdown-bar-line" src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/07c1c16f-22cb-4db6-8e23-639eeefaf70f.png" alt="" />
    } else if (this.state.currentSession === sessionNum && !this.state.editSession) {
      return (
        <div className="coaching-buttons">
          <button
            className="coaching-button coaching-edit"
            disabled={this.state.nextDisabled}
            onClick={this.openSessions.bind(this)}
            aria-label="Click to change current session"
          >
            EDIT
          </button>
          <button
            className="coaching-button coaching-confirm"
            ref={sessionRef}
            disabled={this.state.nextDisabled}
            onClick={this.confirmClick.bind(this)}
            aria-label="Click to change confirm session"
          >
            CONFIRM
          </button>
        </div>
      )
    }
  }
  
  toInspiratorMatch() {
    if (this.state.currentSession && 
      ((this.state.hasSession2 && !this.state.isSessionConfirmed2) || (this.state.hasSession3 && !this.state.isSessionConfirmed3))) {
        return (
          <div className="skip-sessions-wrapper">
            <br aria-hidden="true" />
            <span className="skip-sessions" role="button" tabIndex="0" onClick={this.next}>Continue without scheduling other sessions</span>
          </div>
        )
    } else if (this.state.currentSession) {
      return (
        <div>
          <br aria-hidden="true" />
          <Controls className="coaching-button" nextLabel="MEET YOUR INSPIRATOR" next={this.next} />
        </div>
      )
    }
  }

  render() {
    let session1 = null
    let session2 = null
    let session3 = null

    if (this.state.session1) {
      session1 =
      <div className="session-container">
        {this.displayCheckedImage(true)}
        <div className="session-number-subheader">
        Session 1
        </div>
        <div className="coaching2-subheader">
          {dateFormatting.shortDatePrettyPrint(this.state.session1)}<br />
          {dateFormatting.timePrettyPrint(this.state.session1)}<br />
          BOOKED
        </div>
      </div>
    }

    if (this.state.hasSession2 && this.state.session2) {
      session2 = 
      <div className="session-container">
        {this.displayCheckedImage(this.state.isSessionConfirmed2)}
        <div className={"session-number-subheader " + this.unselectedSession("session2")}>
          Session 2
        </div>
        <div className={"coaching2-subheader " + this.unselectedSession("session2")}>
          {dateFormatting.shortDatePrettyPrint(this.state.session2)}<br />
          {dateFormatting.timePrettyPrint(this.state.session2)}
        </div>
        {this.editConfirmOrDropdwon("session2")}
      </div>
    }
    
    if (this.state.hasSession3 && this.state.session3) {
      session3 =
      <div className="session-container">
        {this.displayCheckedImage(this.state.isSessionConfirmed3)}
        <div className={"session-number-subheader " + this.unselectedSession("session3")}>
          Session 3
        </div>
        <div className={"coaching2-subheader " + this.unselectedSession("session3")}>
          {dateFormatting.shortDatePrettyPrint(this.state.session3)}<br />
          {dateFormatting.timePrettyPrint(this.state.session3)}
        </div>
        {this.editConfirmOrDropdwon("session3")}  
      </div>
    }

    return (
      <div id="coaching2">
        <AriaMessage message="Navigated to book additional coaching sessions page" />
        <Title>Schedule Additional Coaching Sessions</Title>
        <div className="container">
          <div className="coaching-header">
            Success! You've scheduled your first coaching session.
          </div>
          <div className="coaching2-subheader">
            Why stop there! We encourage scheduling one or two more sessions to ensure you get the times that work for you.<br />
            Here are suggested times below.
          </div>
          <div className="sessions-container">
            {session1}
            {session2}
            {session3}
          </div>
          <div>
            {this.displayTimes()}
          </div>
          {this.toInspiratorMatch()}
        </div>
      </div>
    )
  }
}

export default Coaching2